// Remembers which scenarios a visitor has created (by id) in localStorage so the
// server can re-load them on return. Every localStorage touch is guarded: a
// corrupted value, a quota error, or storage being disabled entirely (e.g. Safari
// private mode) must never throw out of `mounted()` — an unhandled throw here
// crashes the hook on the scenario page for that one visitor (#227).
function safeReadIds(key) {
  try {
    const parsed = JSON.parse(localStorage.getItem(key) || "[]")
    return Array.isArray(parsed) ? parsed : []
  } catch (_) {
    return []
  }
}

function safeWriteIds(key, ids) {
  try {
    localStorage.setItem(key, JSON.stringify(ids))
  } catch (_) {
    // Storage full or unavailable — non-fatal, the visitor just won't have their
    // scenario list remembered across visits.
  }
}

export default {
  mounted() {
    const teamAbbr = this.el.dataset.team
    const key = `capsheet_scenarios_${teamAbbr}`

    const saved = safeReadIds(key)
    if (saved.length > 0) {
      this.pushEvent("load_saved_scenarios", {scenario_ids: saved})
    }

    this.handleEvent("scenario_created", ({id}) => {
      const ids = safeReadIds(key)
      if (!ids.includes(id)) {
        ids.push(id)
        safeWriteIds(key, ids)
      }
    })

    this.handleEvent("scenario_deleted", ({id}) => {
      const ids = safeReadIds(key)
      safeWriteIds(key, ids.filter(i => i !== id))
    })
  }
}
